export const isValidVideoUrl = (url: string): boolean =>
  !!url.match(/^.*youtube.*com.*$/i);
